import api from 'Plugins/api'
import Contacts from '../entities/contacts'

class ContactsInteractor {
  /**
   * 获取常旅客列表
   */
  static async getContactsList(query) {
    try {
      const { data: contactsData = {} } = await api['emp/vipEmpContactsPage'](query)
      if (!contactsData.list) contactsData.list = []

      return {
        data: contactsData.list.map(contacts => new Contacts(contacts))
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 根据常旅客Id获取常旅客信息
   */
  static async getContactsById(id) {
    try {
      const { data: contactsData = {} } = await api['emp/vipEmpContactsPage']({
        contactsId: id
      })
      let contact = contactsData.list ? contactsData.list[0] : {}

      return {
        data: new Contacts(contact)
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 保存常旅客信息
   */
  static async saveContacts(payload) {
    try {
      await api['emp/vipEmpContactsEdit'](payload)
    } catch (error) {
      throw error
    }
  }

  static async saveContact(payload) {
    try {
      await api['emp/vipEmpEditDetail'](payload)
    } catch (error) {
      throw error
    }
  }

  /**
   * 删除常旅客
   */
  static async deleteContacts(id) {
    try {
      await api['emp/vipEmpContactsDel']({
        contactsId: id
      })
    } catch (error) {
      throw error
    }
  }

}

export default ContactsInteractor
